"use client";
import React from "react";
import { Popper, PopperProps } from "@mui/material";

export type WcPopperProps = PopperProps;

export const WcPopper = ({ children, ...props }: WcPopperProps) => <Popper {...props}>{children}</Popper>;

export default WcPopper;
